import type React from "react"
import { Card } from "@/components/ui/card"
import { BookOpen, FileText, Clock, AlertCircle } from "lucide-react"

interface StatItem {
  label: string
  value: number
  icon: React.ReactNode
  color: string
}

export function ResourceStats() {
  const stats: StatItem[] = [
    {
      label: "Total Resources",
      value: 42,
      icon: <BookOpen className="w-6 h-6" />,
      color: "bg-blue-100 text-blue-600",
    },
    {
      label: "Assessments",
      value: 12,
      icon: <FileText className="w-6 h-6" />,
      color: "bg-green-100 text-green-600",
    },
    {
      label: "Pending",
      value: 5,
      icon: <Clock className="w-6 h-6" />,
      color: "bg-yellow-100 text-yellow-600",
    },
    {
      label: "Overdue",
      value: 2,
      icon: <AlertCircle className="w-6 h-6" />,
      color: "bg-red-100 text-red-600",
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 bg-slate-200">
      {stats.map((stat) => (
        <Card key={stat.label} className="p-6 flex items-center space-x-4 hover:shadow-lg bg-slate-100 transition-shadow">
          <div className={`p-3 rounded-full ${stat.color}`}>{stat.icon}</div>
          <div>
            <p className="text-sm text-gray-800">{stat.label}</p>
            <p className="text-2xl font-bold text-gray-800">{stat.value}</p>
          </div>
        </Card>
      ))}
    </div>
  )
}
